import { render, staticRenderFns } from "./PaymentThankYouPage.vue?vue&type=template&id=ac36a96a&"
import script from "./PaymentThankYouPage.vue?vue&type=script&lang=js&"
export * from "./PaymentThankYouPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports